// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__37YYv","text":"SelectPayment_text__1uLsN","title":"SelectPayment_title__2NhBs","btn":"SelectPayment_btn__3_KQt"};